export default "__VITE_ASSET__B01_HqFA__"